import { BehaviorSubject } from 'rxjs';
import { AviationEventFilter } from '../models/aviation-event-filter.model';
import * as i0 from "@angular/core";
var AviationEventFiltersService = /** @class */ (function () {
    function AviationEventFiltersService() {
        this.aviationEventFilterSubject$ = new BehaviorSubject(new AviationEventFilter());
        this.aviationEventFilter = this.aviationEventFilterSubject$.asObservable();
    }
    AviationEventFiltersService.prototype.updateAviationEventFilters = function (aviationEventFilter) {
        this.aviationEventFilterSubject$.next(aviationEventFilter);
    };
    AviationEventFiltersService.ngInjectableDef = i0.defineInjectable({ factory: function AviationEventFiltersService_Factory() { return new AviationEventFiltersService(); }, token: AviationEventFiltersService, providedIn: "root" });
    return AviationEventFiltersService;
}());
export { AviationEventFiltersService };
